import styled from 'styled-components';
import { Pulse } from './Pulse';
export var SkeletonSquare = styled(Pulse).withConfig({
  displayName: "SkeletonSquare",
  componentId: "sc-q4u6jm-0"
})(["max-width:100%;border-radius:4px;&:after{display:block;padding-bottom:100%;content:'';}"]);
export var SkeletonExpansible = styled(Pulse).withConfig({
  displayName: "SkeletonSquare__SkeletonExpansible",
  componentId: "sc-q4u6jm-1"
})(["max-width:100%;height:100%;border-radius:4px;"]);